import React, { useEffect, useState } from 'react'
import { AdminPagesService, updateShowMobileSidebarStatus, updateSmallerSideBarStatus, useReturnAdminPagesList } from '../../adminPagesSlice'
import ApplicationLogo from '../../../../components/ApplicationLogo'
import { IAdminPage } from '../../Interfaces'
import AdminSidebarItem from './AdminSidebarItem'
import { Link, useLocation, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../app/store'
import GenerateIcon from '../../../../components/GenerateIcon'
import { useReturnCurrentUser } from '../../../user/userSlice'

export default function AdminSidebar() {

    const location = useLocation()

    const dispatch = useDispatch()
    const pages = useReturnAdminPagesList()

    const { smallerSideBar, showMobileSidebar } = useSelector((state: RootState) => state.adminPages)

    const [mobileSidebarClassName, setMobileSidebarClassName] = useState<string>("mobile-admin-panel-sidebar-wrapper")

    const currentUser = useReturnCurrentUser()

    useEffect(() => {
        const smallSidebarStatusLS = window.localStorage.getItem("small_sidebar")

        if (smallSidebarStatusLS == "enabled"){
            dispatch(updateSmallerSideBarStatus(true))
        }else{
            dispatch(updateSmallerSideBarStatus(false))
        }

    }, [window.localStorage])

    useEffect(() => {
        if (showMobileSidebar){
            setMobileSidebarClassName("mobile-admin-panel-sidebar-wrapper active")
        }else{
            setMobileSidebarClassName("mobile-admin-panel-sidebar-wrapper")
        }
    }, [showMobileSidebar])

    useEffect(() => {
        dispatch(updateShowMobileSidebarStatus(false))
    }, [location.pathname])

    const renderSideButton = () => {
        return(
            <div className="side-button-of-admin-panel-sidebar" onClick={() => dispatch(updateSmallerSideBarStatus(smallerSideBar ? false : true))}>
                <div className="content-of-side-button-of-admin-panel-sidebar">
                    <GenerateIcon icon={smallerSideBar ? "next" : "prev"} />
                </div>
            </div>
        )
    }

    const renderSidebarItems = () => {
        return pages.map((page: IAdminPage, index: number) => {

            if (page.isDaemonOnly){
                if (!currentUser.is_daemon){
                    return <></>
                }
            }

            return <AdminSidebarItem {...page} key={index} />
        })
    }

    return(
        <>

            <div className={smallerSideBar ? "admin-panel-sidebar small-sidebar shown" : "admin-panel-sidebar small-sidebar"}>
                <div className="content-of-admin-panel-sidebar">

                    {renderSideButton()}

                    <div className="logo-of-admin-panel-sidebar">
                        <div className="content-of-logo-of-admin-panel-sidebar">
                            <Link to="/">
                                <ApplicationLogo isIcon />
                            </Link>
                        </div>
                    </div>

                    <div className="menu-of-admin-panel-sidebar">
                        <div className="content-of-menu-of-admin-panel-sidebar">
                            {pages.map((page: IAdminPage, index: number) => <AdminSidebarItem {...page} key={index} />)}
                        </div>
                    </div>

                </div>
            </div>

            <div className={smallerSideBar ? "admin-panel-sidebar desktop-sidebar hide" : "admin-panel-sidebar desktop-sidebar"}>
                <div className="content-of-admin-panel-sidebar">

                    {renderSideButton()}

                    <div className="logo-of-admin-panel-sidebar">
                        <div className="content-of-logo-of-admin-panel-sidebar">
                            <Link to="/">
                                <ApplicationLogo isIcon />
                            </Link>
                        </div>
                    </div>

                    <div className="menu-of-admin-panel-sidebar">
                        <div className="content-of-menu-of-admin-panel-sidebar">
                            {renderSidebarItems()}
                        </div>
                    </div>

                </div>
            </div>

            <div className={mobileSidebarClassName}>
                <div className="admin-panel-sidebar mobile-sidebar">
                    <div className="content-of-admin-panel-sidebar">

                    <div className="side-button-of-admin-panel-sidebar" onClick={() => dispatch(updateShowMobileSidebarStatus(false))}>
                        <div className="content-of-side-button-of-admin-panel-sidebar">
                            <GenerateIcon icon="close" />
                        </div>
                    </div>

                        <div className="logo-of-admin-panel-sidebar">
                            <div className="content-of-logo-of-admin-panel-sidebar">
                                <Link to="/">
                                    <ApplicationLogo isIcon />
                                </Link>
                            </div>
                        </div>

                        <div className="menu-of-admin-panel-sidebar">
                            <div className="content-of-menu-of-admin-panel-sidebar">
                                {renderSidebarItems()}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="mask-of-mobile-admin-panel-sidebar-wrapper" onClick={() => dispatch(updateShowMobileSidebarStatus(false))}></div>
            </div>

        </>
    )
}